import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES, resources } from './config';

/**
 * Language comes from `?lang=hi` in the URL, then the visitor's last choice,
 * then the browser. Missing text falls back to English.
 */

// Screen readers pick a voice from `<html lang>`, and the theme's `:lang(hi)` rules depend on it.
i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES.map((language) => language.code),
    // A browser set to `hi-IN` gets `hi`.
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    defaultNS: 'common',
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    // React already escapes rendered text.
    interpolation: { escapeValue: false },
  });

export default i18n;
